<div *ngIf="showContent">
  <ui5-shellbar primary-title="ITU User Management" >
    <img src="./assets/images/itu_logo_HighRes.png" slot="logo" />
  </ui5-shellbar>
</div>
  
<div class="centered">
  <div id="liteUserRegistration"></div>
</div>
  
